import { getCanaryUserFeatures } from '@api/services/rollout.services';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useFeatureRolloutData() {
    const query = useQuery({ queryKey: ['featureRollouts'], queryFn: () => getCanaryUserFeatures() });

    const hasFeature = useCallback(
        (name: string) => {
            const featureRollouts = query.data || [];

            if (featureRollouts.length === 0) return false;

            const feature = featureRollouts.find((feature: any) => feature.name === name);

            return Boolean(feature);
        },
        [query.data]
    );

    return {
        hasFeature: hasFeature,
    };
}
